import { useEffect, useState } from 'react';
import { useForm, yupResolver, } from '@mantine/form';
import { TextInput, Modal, Text, Center, Button, Code, SimpleGrid, Image, NumberInput, Checkbox } from '@mantine/core';

import seGetProfile from './useGetProfile';
import useUpdateProfile from './useUpdateProfile';

import { object, string } from "yup";

const userSchema = object().shape({
    name: string()
        .required("Name is required")
        .min(3, "Name must be at least 3 characters"),

    email: string()
        .required("Email is required")
        .email("Your Email address is invalid"),

    tiktok_username: string()
        .required("Tiktok username is required")
        .min(3, "Tiktok username must be at least 3 characters"),

    //  country_code: string()
    //     .required("Country code is required")
    //     .min(1, "Country code must be at least 1 characters")
    //     .max(4, "Country code must be max 4 characters"),

    // phone: string()
    //     .required("Phone number is required")
    //     .min(8, "Phone number must be at least 8 characters")
    //     .max(15, "Phone number must be max 15 characters"),
});
function Demo() {
    const {
        editMutation
    } = useUpdateProfile()

    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (event) => {
        console.log(event); // Log the event
        if (event.target && event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            setSelectedFile(file);
        } else {
            console.log('No file selected or event target is undefined');
        }
    };

    const { data, isPending, isError } = seGetProfile();
    console.log({
        data, isPending, isError
    });

    useEffect(() => {
        if (!isPending && data) {
            form?.setValues({ ...data })
        }
    }, [data, isPending]);

    const [submittedValues, setSubmittedValues] = useState('');

    const form = useForm({
        mode: 'uncontrolled',
        initialValues: {
            name: data?.name,
            email: data?.email,
            tiktok_username: data?.tiktok_username,
            // country_code: data?.country_code,
            // phone: data?.phone,


        },
        validate: yupResolver(userSchema)
    });
    const handleEdit = form.onSubmit(async (values) => {
        console.log("values", values);
        const formData = new FormData();
        formData.append("id", values?.id);
        formData.append("name", values?.name);
        formData.append("email", values?.email);
        formData.append("tiktok_username", values?.tiktok_username);
        //formData.append("country_code", values?.country_code);
        // formData.append("phone", values?.phone);
        // formData.append("code", values?.code);
        selectedFile && formData.append("file", selectedFile, selectedFile?.name);
        editMutation.mutate(formData)
    })

    return (
        <>
            <h1>Update Profile</h1>


            <SimpleGrid cols={2}>

                <TextInput
                    label="Name"
                    placeholder="Enter Name"
                    key={form.key('name')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('name')}
                />

                {/* <TextInput
                    label="Code"
                    placeholder="Enter Code"
                    key={form.key('code')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('code')}
                /> */}

                <TextInput
                    label="Email"
                    placeholder="Enter Email"
                    key={form.key('email')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('email')}
                    disabled
                />

                <TextInput
                    label="Tiktok Username"
                    placeholder="Enter Tiktok Username"
                    key={form.key('tiktok_username')}
                    style={{ alignSelf: "baseline" }}
                    {...form.getInputProps('tiktok_username')}
                />

                <SimpleGrid cols={2}>

                    <TextInput type="file" accept="image/png,image/jpeg,image/jpg" label="Upload Logo Image" placeholder="Upload file" onChange={handleFileChange} />

                    <Image height={100} width={100} src={selectedFile ? URL.createObjectURL(selectedFile) : data?.image?.url} />
                </SimpleGrid>

                {/* <SimpleGrid cols={2}>

                    <NumberInput
                        label="Country code"
                        placeholder="Enter Country code"
                        key={form.key('country_code')}
                        style={{ alignSelf: "baseline" }}
                        {...form.getInputProps('country_code')}
                    />

                    <NumberInput
                        label="Phone number"
                        placeholder="Enter Phone number"
                        key={form.key('phone')}
                        style={{ alignSelf: "baseline" }}
                        {...form.getInputProps('phone')}
                    />

                </SimpleGrid> */}



            </SimpleGrid>
            <Button type="submit" mt="md" onClick={handleEdit} loading={editMutation?.isPending}>
                Submit
            </Button>

            {submittedValues && (
                <Code block mt="md">
                    {submittedValues}
                </Code>
            )}
        </>
    );
}



export default Demo;
